module.exports = __webpack_public_path__ + "media/img/private-venue/professional-c82957f3d564494c837815c109d66405.svg";